import { createSlice } from "@reduxjs/toolkit";
import {
  Bank,
  CreditCardTypes,
  DealTypes,
  PaymentTypes,
} from "../../models/PaymentData.model";
import { loginUser } from "../thunks/authThunks";
import { refreshCompanyData } from "../thunks/companyDataThunks";

interface PaymentDataState {
  // נתוני תשלומים
  banks: Bank[];
  creditCardTypes: CreditCardTypes[];
  dealTypes: DealTypes[];
  paymentTypes: PaymentTypes[];

  // מצבי טעינה ושגיאות
  loading: boolean;
  error: string | null;

  // מצב אתחול
  initialized: boolean;
}

const initialState: PaymentDataState = {
  banks: JSON.parse(sessionStorage.getItem("banks") || "[]"),
  creditCardTypes: JSON.parse(
    sessionStorage.getItem("creditCardTypes") || "[]"
  ),
  dealTypes: JSON.parse(sessionStorage.getItem("dealTypes") || "[]"),
  paymentTypes: JSON.parse(sessionStorage.getItem("paymentTypes") || "[]"),

  loading: false,
  error: null,
  initialized: false,
};

const paymentDataSlice = createSlice({
  name: "paymentData",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
    },
    resetPaymentDataState: (state) => {
      Object.assign(state, {
        banks: [],
        creditCardTypes: [],
        dealTypes: [],
        paymentTypes: [],
        loading: false,
        error: null,
        initialized: false,
      });

      // ניקוי session storage
      sessionStorage.removeItem("banks");
      sessionStorage.removeItem("creditCardTypes");
      sessionStorage.removeItem("dealTypes");
      sessionStorage.removeItem("paymentTypes");
    },
    clearPaymentDataOnCompanyChange: (state) => {
      // נתוני תשלומים לא תלויים בחברה אז לא מנקים אותם
      // רק מנקים שגיאות
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // האזנה לאימות מוצלח
      .addCase(loginUser.fulfilled, (state, action) => {
        const { banks, creditCardTypes, dealTypes, paymentTypes } =
          action.payload;


        if (banks && banks.length > 0) {
          state.banks = banks;
          sessionStorage.setItem("banks", JSON.stringify(banks));
        }

        if (creditCardTypes && creditCardTypes.length > 0) {
          state.creditCardTypes = creditCardTypes;
          sessionStorage.setItem(
            "creditCardTypes",
            JSON.stringify(creditCardTypes)
          );
        }

        if (dealTypes && dealTypes.length > 0) {
          state.dealTypes = dealTypes;
          sessionStorage.setItem("dealTypes", JSON.stringify(dealTypes));
        }

        if (paymentTypes && paymentTypes.length > 0) {
          state.paymentTypes = paymentTypes;
          sessionStorage.setItem("paymentTypes", JSON.stringify(paymentTypes));
        }

        state.initialized = true;
        state.loading = false;
        state.error = null;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // האזנה לרענון נתוני חברה
      .addCase(refreshCompanyData.fulfilled, (state, action) => {
        const { banks, creditCardTypes, dealTypes, paymentTypes } = action.payload;
        
        if (banks) {
          state.banks = banks;
          sessionStorage.setItem("banks", JSON.stringify(banks));
        }
        if (creditCardTypes) {
          state.creditCardTypes = creditCardTypes;
          sessionStorage.setItem("creditCardTypes", JSON.stringify(creditCardTypes));
        }
        if (dealTypes) {
          state.dealTypes = dealTypes;
          sessionStorage.setItem("dealTypes", JSON.stringify(dealTypes));
        }
        if (paymentTypes) {
          state.paymentTypes = paymentTypes;
          sessionStorage.setItem("paymentTypes", JSON.stringify(paymentTypes));
        }
        
        state.initialized = true;
        state.error = null;
      });
  },
});

export const {
  clearMessages,
  resetPaymentDataState,
  clearPaymentDataOnCompanyChange,
} = paymentDataSlice.actions;

export default paymentDataSlice.reducer;
